import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';
import SkeletonPage from '../modules/skeleton/SkeletonPage';

const SitesPage = lazy(
  () => import('../modules/attendance-management/sites/SitesPage')
);
const SchedulesPage = lazy(
  () => import('../modules/attendance-management/schedules/SchedulesPage')
);
const MarkAttendancePage = lazy(
  () =>
    import(
      '../modules/attendance-management/mark-attendance/MarkAttendancePage'
    )
);
const AttendanceRegisterPage = lazy(
  () =>
    import(
      '../modules/attendance-management/attendance-register/AttendanceRegisterPage'
    )
);
const ShiftsPage = lazy(
  () => import('../modules/attendance-management/shifts/ShiftsPage')
);
const PayslipPage = lazy(
  () => import('../modules/attendance-management/payslip/PayslipPage')
);
const PayslipDetailsPage = lazy(
  () => import('../modules/attendance-management/payslip/PayslipDetailsPage')
);
const MyTimeCardsPage = lazy(
  () => import('../modules/attendance-management/my-time-cards/MyTimeCardsPage')
);
const LeaveManagementPage = lazy(
  () =>
    import(
      '../modules/attendance-management/leave-management/LeaveManagementPage'
    )
);
const LeaveSetupPage = lazy(
  () =>
    import(
      '../modules/attendance-management/leave-management/pages/LeaveSetupPage'
    )
);
const LeaveAssignPage = lazy(
  () =>
    import(
      '../modules/attendance-management/leave-management/pages/LeaveAssignPage'
    )
);
const LeaveRequestsPage = lazy(
  () =>
    import(
      '../modules/attendance-management/leave-management/pages/LeaveRequestsPage'
    )
);
const ApplyLeavePage = lazy(
  () =>
    import(
      '../modules/attendance-management/leave-management/pages/ApplyLeavePage'
    )
);
const MyLeaveRequestsPage = lazy(
  () =>
    import(
      '../modules/attendance-management/leave-management/pages/MyLeaveRequestsPage'
    )
);
const CompanyLeavesPage = lazy(
  () =>
    import(
      '../modules/attendance-management/leave-management/pages/CompanyLeavesPage'
    )
);

const MyPayslipPage = lazy(
  () => import('../modules/attendance-management/payslip/MyPayslipPage')
);

const FaceValidationPage = lazy(
  () => import('../modules/attendance-management/face-validation/FaceValidationPage')
);

const GlobalAttendancePage = lazy(
  () => import('../modules/attendance-management/global-attendance/GlobalAttendancePage')
);

const AttendanceRoutes = (
  <Route path="attendance">
    <Route
      path="face-validation"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <FaceValidationPage />
        </Suspense>
      }
    />
    <Route
      path="global-attendance"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <GlobalAttendancePage />
        </Suspense>
      }
    />
    <Route
      path="locations"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <SitesPage />
        </Suspense>
      }
    />
    <Route
      path="schedules"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <SchedulesPage />
        </Suspense>
      }
    />
    <Route
      path="mark-attendance"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <MarkAttendancePage />
        </Suspense>
      }
    />
    <Route
      path="shifts"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <ShiftsPage />
        </Suspense>
      }
    />
    <Route
      path="register"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <AttendanceRegisterPage />
        </Suspense>
      }
    />
    <Route
      path="my-attendance"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <MyTimeCardsPage />
        </Suspense>
      }
    />
    <Route
      path="leave-management"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <LeaveManagementPage />
        </Suspense>
      }
    />
    <Route
      path="leave-management/setup"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <LeaveSetupPage />
        </Suspense>
      }
    />
    <Route
      path="leave-management/assign"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <LeaveAssignPage />
        </Suspense>
      }
    />
    <Route
      path="leave-management/requests"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <LeaveRequestsPage />
        </Suspense>
      }
    />
    <Route
      path="apply-leave"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <ApplyLeavePage />
        </Suspense>
      }
    />
    <Route
      path="my-leave-requests"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <MyLeaveRequestsPage />
        </Suspense>
      }
    />
    <Route
      path="company-leaves"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <CompanyLeavesPage />
        </Suspense>
      }
    />

    <Route
      path="my-payslip"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <MyPayslipPage />
        </Suspense>
      }
    />
    <Route
      path="payslip"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <PayslipPage />
        </Suspense>
      }
    />
    <Route
      path="payslip/details/:id"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <PayslipDetailsPage />
        </Suspense>
      }
    />
  </Route>
);

export default AttendanceRoutes;
